import React from "react";
import { Platform, ScrollView, StyleSheet, Text, View } from "react-native";
import { BottomBarDLSType, ButtonTypeDLS, ColorTokens, IconSizeTokens, IconTokens, ImageSizeTokens, SizeTypeTokens, TypographyTypeDLS } from "@voltmoney/schema";
import BottomBar from "../../bottomBarDLS/bottomBarDLS";
import { Typography } from "../../typography/Typography";
import { Space } from "../../space/Space";
import { Icon } from "../../icon/Icon";
import ThemeProvider from "@voltmoney/theme";
import { Image } from "../../image/Image";
import { LENDER_ID } from "../constants";
const LoanRenewalLearnMorePage = ({ loanExpiryDay, penalInterest, ctaAction, height, lenderId, triggerAction }) => {
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    const BenefitCardDivider = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement(Space, { size: SizeTypeTokens.XL }),
            React.createElement(View, { style: {
                    height: 1,
                    width: '100%',
                    backgroundColor: colorMapping[ColorTokens.Secondary_10]
                } }),
            React.createElement(Space, { size: SizeTypeTokens.XL })));
    };
    const BenefitCard = () => {
        return (React.createElement(View, { style: [
                {
                    borderColor: colorMapping[ColorTokens.Grey_Chalk]
                },
                styles.card1
            ] },
            React.createElement(View, { style: styles.card1ItemContainer },
                React.createElement(Image, { size: ImageSizeTokens.SM, uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/loanRenewalGreenTrending.svg' }),
                React.createElement(Space, { size: SizeTypeTokens.LG }),
                React.createElement(View, { style: {
                        flex: 1
                    } },
                    React.createElement(Text, null,
                        React.createElement(Typography, { label: 'Continued access to ', typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Night }),
                        React.createElement(Typography, { label: 'instant funds', typeDLS: TypographyTypeDLS.B1M, color: ColorTokens.Secondary_100 })))),
            BenefitCardDivider(),
            React.createElement(View, { style: styles.card1ItemContainer },
                React.createElement(Image, { size: ImageSizeTokens.SM, uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/loanRenewalGreenRupee.svg' }),
                React.createElement(Space, { size: SizeTypeTokens.LG }),
                React.createElement(View, { style: {
                        flex: 1
                    } },
                    React.createElement(Text, null,
                        React.createElement(Typography, { label: 'Avoid repayment ', typeDLS: TypographyTypeDLS.B1M, color: ColorTokens.Secondary_100 }),
                        React.createElement(Typography, { label: 'of outstanding amount', typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Night })))),
            BenefitCardDivider(),
            React.createElement(View, { style: styles.card1ItemContainer },
                React.createElement(Image, { size: ImageSizeTokens.SM, uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/loanRenewalGreenTrending.svg' }),
                React.createElement(Space, { size: SizeTypeTokens.LG }),
                React.createElement(View, { style: {
                        flex: 1
                    } },
                    React.createElement(Text, null,
                        React.createElement(Typography, { label: 'Let your portfolio grow ', typeDLS: TypographyTypeDLS.B1M, color: ColorTokens.Secondary_100 }),
                        React.createElement(Typography, { label: '& meet long term goals', typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Night }))))));
    };
    const RenewalFailurePenaltyFailureCard = () => {
        return (React.createElement(View, null,
            lenderId?.toLowerCase() === LENDER_ID.TATA && React.createElement(View, { style: styles.card2ItemContainer },
                React.createElement(Icon, { name: IconTokens.CoveredRightArrow, size: IconSizeTokens.XL, color: ColorTokens.Grey_Smoke }),
                React.createElement(Space, { size: SizeTypeTokens.LG }),
                React.createElement(View, { style: {
                        flex: 1
                    } },
                    React.createElement(Typography, { label: 'If you prefer not to renew, please initiate a foreclosure request 5 days before your loan expires.', typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.Grey_Charcoal }))),
            lenderId?.toLowerCase() === LENDER_ID.TATA && React.createElement(Space, { size: SizeTypeTokens.LG }),
            React.createElement(View, { style: styles.card2ItemContainer },
                React.createElement(Icon, { name: IconTokens.CoveredRightArrow, size: IconSizeTokens.XL, color: ColorTokens.Grey_Smoke }),
                React.createElement(Space, { size: SizeTypeTokens.LG }),
                React.createElement(View, { style: {
                        flex: 1
                    } },
                    React.createElement(Text, null,
                        React.createElement(Typography, { label: 'Outstanding amount to be repaid within ', typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.Grey_Charcoal }),
                        React.createElement(Typography, { label: `${loanExpiryDay} days `, typeDLS: TypographyTypeDLS.B2S, color: ColorTokens.Grey_Charcoal }),
                        React.createElement(Typography, { label: 'of loan expiry', typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.Grey_Charcoal })))),
            React.createElement(Space, { size: SizeTypeTokens.LG }),
            React.createElement(View, { style: styles.card2ItemContainer },
                React.createElement(Icon, { name: IconTokens.CoveredRightArrow, size: IconSizeTokens.XL, color: ColorTokens.Grey_Smoke }),
                React.createElement(Space, { size: SizeTypeTokens.LG }),
                React.createElement(View, { style: {
                        flex: 1
                    } },
                    React.createElement(Text, null,
                        React.createElement(Typography, { label: 'Portfolio will be ', typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.Grey_Charcoal }),
                        React.createElement(Typography, { label: 'sold off ', typeDLS: TypographyTypeDLS.B2S, color: ColorTokens.Grey_Charcoal }),
                        React.createElement(Typography, { label: 'to recover outstanding amount if you fail to repay in 7 days', typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.Grey_Charcoal })))),
            React.createElement(Space, { size: SizeTypeTokens.LG }),
            React.createElement(View, { style: styles.card2ItemContainer },
                React.createElement(Icon, { name: IconTokens.CoveredRightArrow, size: IconSizeTokens.XL, color: ColorTokens.Grey_Smoke }),
                React.createElement(Space, { size: SizeTypeTokens.LG }),
                React.createElement(View, { style: {
                        flex: 1
                    } },
                    React.createElement(Text, null,
                        React.createElement(Typography, { label: 'Penal interest ', typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.Grey_Charcoal }),
                        React.createElement(Typography, { label: `@ ${penalInterest}% per month `, typeDLS: TypographyTypeDLS.B2S, color: ColorTokens.Grey_Charcoal }),
                        React.createElement(Typography, { label: 'will be charged on outstanding amount', typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.Grey_Charcoal })))),
            React.createElement(Space, { size: SizeTypeTokens.LG }),
            React.createElement(View, { style: styles.card2ItemContainer },
                React.createElement(Icon, { name: IconTokens.CoveredRightArrow, size: IconSizeTokens.XL, color: ColorTokens.Grey_Smoke }),
                React.createElement(Space, { size: SizeTypeTokens.LG }),
                React.createElement(View, { style: {
                        flex: 1
                    } },
                    React.createElement(Text, null,
                        React.createElement(Typography, { label: 'Negative impact on ', typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.Grey_Charcoal }),
                        React.createElement(Typography, { label: 'CIBIL ', typeDLS: TypographyTypeDLS.B2S, color: ColorTokens.Grey_Charcoal }),
                        React.createElement(Typography, { label: 'score if you fail to repay', typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.Grey_Charcoal }))))));
    };
    const body = () => {
        return (React.createElement(View, { style: styles.bodycontainer },
            React.createElement(View, { style: {
                    paddingHorizontal: 16,
                    paddingBottom: 16,
                    borderBottomWidth: 1,
                    borderColor: colorMapping[ColorTokens.Grey_Chalk]
                } },
                React.createElement(Typography, { label: 'Benefits of loan renewal', typeDLS: TypographyTypeDLS.H4B }),
                React.createElement(Space, { size: SizeTypeTokens.LG }),
                BenefitCard()),
            React.createElement(Space, { size: SizeTypeTokens.XL }),
            React.createElement(View, { style: {
                    paddingHorizontal: 16,
                } },
                React.createElement(Typography, { label: 'What happens if you do not renew?', typeDLS: TypographyTypeDLS.H4B }),
                React.createElement(Space, { size: SizeTypeTokens.XL }),
                RenewalFailurePenaltyFailureCard())));
    };
    const footer = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement(BottomBar, { onPress: () => {
                    ctaAction &&
                        triggerAction(ctaAction);
                }, btnLabel: 'Ok, got it!', typeDLS: BottomBarDLSType.TYPE_A, btnTypeDLS: ButtonTypeDLS.PRIMARY })));
    };
    return (React.createElement(View, { style: [
            {
                height: Platform.OS === "ios" ? height - 52 : height
            }
        ] },
        React.createElement(ScrollView, { style: {
                flex: 1
            } }, body()),
        footer()));
};
const styles = StyleSheet.create({
    bodycontainer: {
        paddingVertical: 24,
        marginBottom: 81,
    },
    card1: {
        padding: 12,
        borderRadius: 8,
        borderWidth: 1,
        shadowColor: 'rgba(152, 162, 179, 0.20)',
        shadowOffset: {
            width: 0,
            height: 6,
        },
        shadowOpacity: 1,
        shadowRadius: 20,
        elevation: 0, // For Android
    },
    card1ItemContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%'
    },
    card2ItemContainer: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%'
    }
});
export default LoanRenewalLearnMorePage;
